import type { VisibilityKey } from "@/content/schema";

/** Whether an object is visible at `frame`, given its sorted [frame, hidden] keys (Blender hide_render keys). */
export function visibleAt(
	keys: readonly VisibilityKey[],
	frame: number,
): boolean {
	let hidden = false;
	for (const [f, h] of keys) {
		if (f <= frame) hidden = h;
		else break;
	}
	return !hidden;
}
